"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventBodyFactory = void 0;
const Factory = require("factory.ts");
const Mocks = require("../../../mocks");
exports.eventBodyFactory = Factory.Sync.makeFactory({
    description: 'Test Event Body',
    end_date_time: Mocks.dates.date2100,
    local_timezone: 'America/Chicago',
    location_address: '1234 Main St',
    location_description: 'Home',
    location_place_id: 'abc',
    start_date_time: Mocks.dates.date2000,
    status: 'Scheduled',
    type: 'event',
});
